<template>
  <div></div>
</template>
<script>
import helpers from "@/helpers"
import { baseApiUrl } from "@/global"
import axios from "axios"

import pdfmake from "pdfmake"
import pdffonts from "pdfmake/build/vfs_fonts.js"

export default {
  data() {
    return {
      data: [],
      orders: []
    }
  },
  methods: {
    async generate(filters) {
      this.orders = []
      this.filters = filters
      this.helpers = helpers

      if (!pdfmake.vfs) {
        pdfmake.vfs = pdffonts.pdfMake.vfs;
      }
      await this.getOrders()
      this.fixVarsToTable()
      if (!this.orders.length) return false
      this.makePDF()
      return true
    },
    async getOrders() {
      try {
        this.$vs.loading()
        const response = await axios.post(`${baseApiUrl}/report/saleReport`, {
          representante: this.filters.representante,
          orderBy: this.filters.orderBy.code
        })
        this.data = response.data
      } catch (error) {
        this.$vs.notify({
          title: 'Erro',
          text: error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    fixVarsToTable() {
      for (const index in this.data) {
        const order = this.data[index]
        this.orders.push([
          +index + 1,
          order.cliente,
          order.representante,
          // this.helpers.dateHelper.formatDateToPTBR(order.primeiraCompra),
          this.helpers.dateHelper.formatDateToPTBR(order.ultimaCompraRegnaparts),
          this.helpers.dateHelper.formatDateToPTBR(order.ultimaCompraRevestebem),
          this.helpers.moneyHelper.formatNumberToCurrency(order.valorUltimaCompraRegnaparts),
          this.helpers.moneyHelper.formatNumberToCurrency(order.valorUltimaCompraRevestebem),
          this.helpers.moneyHelper.formatNumberToCurrency(order.valorTotal),
          { text: order.numeroPedidos, alignment: 'right' },
        ])
      }
    },
    makePDF() {
      let docDefinition = {
        info: {
          title: `RELATORIO - VENDAS`,
        },
        content: [{
            alignment: "center",
            text: 'Relatório de Vendas | Gerado em: ' + this.helpers.dateHelper.getDateTimePTBR(),
            bold: true,
            fontSize: 12,
          },
          {
            alignment: "center",
            text: 'Ordenado por: ' + this.filters.orderBy.label,
            bold: true,
            margin: [0, 0, 0, 10],
            fontSize: 11,
          },
          {
            table: {
              headerRows: 1,
              widths: ['*', 'auto', 'auto', '8%', '8%', '8%', '8%', '8%', '5%'],
              body: [
                [{
                    text: 'N°',
                    bold: true
                  },
                  {
                    text: 'CLIENTE',
                    bold: true
                  },
                  {
                    text: 'REPRESENTANTE',
                    bold: true
                  },
                  // {
                  //   text: 'PRIM. COMPRA',
                  //   bold: true
                  // },
                  {
                    text: 'ULT. COMPRA REGNAPARTS',
                    bold: true
                  },
                  {
                    text: 'ULT. COMPRA REVESTEBEM',
                    bold: true
                  },
                  {
                    text: 'VLR. ULT. REGNAPARTS',
                    bold: true
                  },
                  {
                    text: 'VLR. ULT. REVESTEBEM',
                    bold: true
                  },
                  {
                    text: 'VLR. TOTAL',
                    bold: true
                  },
                  {
                    text: 'QTD. PEDIDOS',
                    bold: true
                  }
                ],
                ...this.orders,
              ]
            },
          }
        ],
        defaultStyle: {
          fontSize: 8,
        },
        pageMargins: [20, 20],
        pageOrientation: 'landscape',
      }
      docDefinition = JSON.parse(JSON.stringify(docDefinition))
      pdfmake.createPdf(docDefinition).open()
    }
  },
}

</script>
